import { BaseDispatcher } from './base'

export enum UserDispatchTypes {
    USER_SUCCESS = 'USER_SUCCESS',
    USER_TOKEN = 'USER_TOKEN',
    USER_REQUEST = 'USER_REQUEST',
    USER_WHOAMI_SUCCESS = 'USER_WHOAMI_SUCCESS',
    USER_LOGOUT = 'USER_LOGOUT',
    USER_ERROR = 'USER_ERROR',
    USER_PERMISSIONS_SUCCESS = 'USER_PERMISSIONS_SUCCESS',
}
export class UserDispatcher extends BaseDispatcher {
    static UserRequest = (): any => {
        return new UserDispatcher(
            UserDispatchTypes.USER_REQUEST,
            {}
        ).onDispatchSuccess()
    }

    static UserSuccess = (success: any): any => {
        return new UserDispatcher(
            UserDispatchTypes.USER_SUCCESS,
            success
        ).onDispatchSuccess()
    }

    static UserWhoAmISuccess = (success: any): any => {
        return new UserDispatcher(
            UserDispatchTypes.USER_WHOAMI_SUCCESS,
            success
        ).onDispatchSuccess()
    }

    static UserError = (error: any): any => {
        return new UserDispatcher(
            UserDispatchTypes.USER_ERROR,
            error
        ).onDispatchError()
    }
}
